/**
 * Author component for the single pages
 */

// Import statements
import React from "react"
import parse from "html-react-parser"
import {graphql, Link, useStaticQuery} from "gatsby"

/**
 * Define the Author constant
 * @param author
 * @returns {JSX.Element}
 * @constructor
 */
const Author = ({author}) => {

    // ----------------------
    // BUILD TIME DATA FETCHING USING GRAPHQL
    // ----------------------
    const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          instagram_url
          facebook_url
        }
      }
    }
  `)

    // define the description
    let description = null;
    if (author?.slug === 'judith') {
        description = author?.description
            .replace('Instagram', '<a href="' + data.site.siteMetadata.instagram_url + '">Instagram</a>')
            .replace('Facebook', '<a href="' + data.site.siteMetadata.facebook_url + '">Facebook</a>')
    } else {
        description = author?.description || null;
    }

    // get avatar URL
    const avatarUrl = author?.avatar?.url

    // return JSX
    return (
        <div className="row row-no-margin">
            <div className="col-xs-12 text-small" id="author-block">
                {avatarUrl && (
                    <Link to={author?.uri} title={author?.nicename}>
                        <img
                            alt={author?.firstName || ``}
                            className="bio-avatar"
                            src={avatarUrl}
                        />
                    </Link>
                )}
                <p>
                    {parse(description ?? '')}
                </p>
            </div>
        </div>
    )
}

/**
 * Export the Author variable
 */
export default Author
